import {WorksitesTableProps} from "./types";
import React, {createRef, useCallback, useContext, useEffect, useMemo, useState} from "react";
import UserNotificationsContext from "../../../../UserNotificationsContext";
import TableStyle from "@components/TableStyle";
import MaterialTable from "@material-table/core";
import {tableIcons} from "@ui-components/TableIcons";
import {sharingInfoModal} from "@components/Modals/SharingInfoModal";
import AuthenticationService from "@services/AuthenticationService";
import {useHomeWorksites} from "@feature/worksites/home/hooks/useHomeWorksites";
import {useIntl} from "react-intl";
import {WorksitesWithIdSchema} from "@feature/types";
import {getColumns, OPTIONS, LOCALIZATION} from "@feature/worksites/home/table/lib/utils";
import {ADVANCED_CONTROL_ROLES} from "@feature/worksites/home/filters/lib/consts";
import _ from "lodash";

export const WorksitesTable = ({filters, users, refreshObservable}: WorksitesTableProps) => {

  // context
  const { userNotifications } = useContext(UserNotificationsContext) as any;

  // hooks
  const intl = useIntl();
  const {loading, fetchWorksitesPage: fetch} = useHomeWorksites();

  // state
  const [showSharing, setShowSharing] = useState(false);

  // ref
  const ref = createRef<MaterialTable<WorksitesWithIdSchema>>();

  // utils
  const userData = AuthenticationService.getUserData();
  const showFlgTest = ADVANCED_CONTROL_ROLES.includes(userData.role);
  const columns = useMemo(
    () => getColumns(intl, showFlgTest, setShowSharing, users, userNotifications),
    [users, userNotifications],  // eslint-disable-line react-hooks/exhaustive-deps
  );
  const debouncedQueryChange = useCallback(() => {
      // @ts-ignore
      ref.current?.onQueryChange();
    },
    [ref, refreshObservable]  // eslint-disable-line react-hooks/exhaustive-deps
  );

  useEffect(() => {
    debouncedQueryChange();
  }, [JSON.stringify(filters), refreshObservable]);

  return (
    <>
      <TableStyle>
        <MaterialTable<WorksitesWithIdSchema>
          tableRef={ref}
          columns={columns}
          data={(query) => fetch(filters, query)}
          icons={tableIcons}
          isLoading={loading}
          options={OPTIONS}
          localization={LOCALIZATION}
        />
      </TableStyle>
      {showSharing && sharingInfoModal(showSharing, setShowSharing, false, intl)}
    </>
  );
}